import React, { useState } from "react";
import "./datatable.scss";
import tableup from "../../../../assets/tableup.svg";
import tabledown from "../../../../assets/tabledown.svg";
import { Accordion, Modal } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";

const DataTable = ({
  tokenData,
  toggleStatus,
  setOrderDirection,
  setOrderField,
  isAdmin,
  isAutomated,
}) => {
  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };
  const [showMore, setShowMore] = useState(false); // hidden by default

  const toggleMoreInfo = () => {
    setShowMore((prev) => !prev);
  };
  return (
    <>
      <section className="datatable">
        <div className="newsideedesktop">
          <div className="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>
                    <div
                      className="parent-tag"
                      style={{ cursor: isAutomated ? "" : "pointer" }}
                      onClick={() => {
                        if (isAutomated) return;
                        setOrderField("name");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1
                        );
                      }}
                    >
                      Token
                      <div className="filter-btn">
                        <svg
                          width="9"
                          height="6"
                          viewBox="0 0 9 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                            fill="#77868B"
                          />
                        </svg>
                        <svg
                          width="9"
                          height="6"
                          viewBox="0 0 9 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                            fill="#77868B"
                          />
                        </svg>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      className="parent-tag"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (isAutomated) {
                          setOrderField("tokenSymbol");
                        } else {
                          setOrderField("symbol");
                        }
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1
                        );
                      }}
                    >
                      Symbol
                    </div>
                  </th>
                  <th>
                    <div
                      className="parent-tag"
                      style={{ cursor: isAutomated ? "" : "pointer" }}
                      onClick={() => {
                        if (isAutomated) return;
                        setOrderField("decimal");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1
                        );
                      }}
                    >
                      Token Decimal
                    </div>
                  </th>
                  <th>
                    <div
                      className="parent-tag"
                      style={{ cursor: isAutomated ? "" : "pointer" }}
                      onClick={() => {
                        if (isAutomated) return;
                        setOrderField("address");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1
                        );
                      }}
                    >
                      Contract Address
                    </div>
                  </th>

                  <th>
                    <div
                      className="parent-tag"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (isAutomated) {
                          setOrderField("isActive");
                        } else {
                          setOrderField("status");
                        }
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1
                        );
                      }}
                    >
                      Status
                    </div>
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tokenData?.length > 0
                  ? tokenData?.map((item, index) => {
                      const address = isAutomated
                        ? item?.tokenContractAddress
                        : item?.address;
                      const imageUrl = isAutomated
                        ? item?.imageUrl?.toLowerCase()
                        : item?.symbol?.toLowerCase();
                      const symbol = isAutomated
                        ? item?.tokenSymbol
                        : item?.symbol;
                      const decimals = isAutomated
                        ? item?.tokenDecimals
                        : item?.decimal;
                      const status = isAutomated
                        ? item?.isActive
                        : item?.status;
                      return (
                        <>
                          <tr>
                            <td>
                              <div className="forflex">
                                <div className="tokenimg">
                                  {/* {item?.address ==
                                "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" ? (
                                  <img
                                    src="\assets\ethereum-et.svg"
                                    alt="innertokenimg"
                                    className="innertokenimg"
                                  />
                                ) : (
                                )} */}
                                  <img
                                    src={
                                      isAutomated
                                        ? imageUrl
                                        : `assets/${imageUrl}.svg`
                                    }
                                    alt="innertokenimg"
                                    className="innertokenimg"
                                  />
                                </div>

                                {!isAutomated &&
                                  (item?.address ==
                                  "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" ? (
                                    <p className="tokenname">Ethereum</p>
                                  ) : (
                                    <p className="tokenname">{item?.name}</p>
                                  ))}
                              </div>
                            </td>
                            <td>{symbol}</td>
                            <td>{decimals}</td>
                            <td>
                              <div className="forflex">
                                {/* <p className="tokenname">{item?.address}</p> */}
                                {copy ? (
                                  <span className="adadasdasdasdasdasdsad">
                                    {address}
                                    <svg
                                      style={{ cursor: "pointer" }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      className=""
                                    >
                                      <path
                                        d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </span>
                                ) : (
                                  <>
                                    {address && (
                                      <CopyToClipboard
                                        text={address}
                                        onCopy={textCopiedFun2}
                                      >
                                        <span className="adadasdasdasdasdasdsad">
                                          {address}
                                          <svg
                                            style={{ cursor: "pointer" }}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            className=""
                                          >
                                            <path
                                              d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                              stroke="#77868B"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                              stroke="#77868B"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </span>
                                      </CopyToClipboard>
                                    )}
                                  </>
                                )}
                              </div>
                            </td>

                            {status == false ? (
                              <td className="red">Inactive</td>
                            ) : (
                              <td className="green">Active</td>
                            )}

                            {isAdmin && (
                              <td>
                                <div className="parent-toggle-switch-custom">
                                  <div class="custom-toggle">
                                    <input
                                      type="checkbox"
                                      class="checkbox"
                                      id={item?._id}
                                      defaultChecked={status}
                                      onChange={() => {
                                        toggleStatus(item?._id);
                                      }}
                                    />
                                    <label class="switch red" for={item?._id}>
                                      <span class="slider"></span>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        </>
                      );
                    })
                  : null}
              </tbody>
            </table>
            {/* <div className="footer-content">
            <div className="left-f">
            </div>
            <nav className="right-f">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    onClick={() => getPrevData(currentPage)}
                    className="page-link arrowssss scsdsdfefssdvsdvsd"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M10 13L5 8L10 3" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
                {pages?.map((item, index) => {
                  return (
                    <li key={index} className="page-item cursor-pointer">
                      <p
                        className={
                          "page-link " +
                          (index + 1 === parseInt(currentPage)
                            ? "active-pag"
                            : "")
                        }
                        onClick={() => GetAllRounds(index + 1)}
                        style={{ fontSize: "13px !important" }}
                      >
                        {index + 1}
                      </p>
                    </li>
                  );
                })}
                <li className="page-item">
                  <button
                    onClick={() => getNextData(currentPage)}
                    className="page-link arrowssss"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M5 13L10 8L5 3" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </button>
                </li>
              </ul>
            </nav>
          </div> */}
          </div>
        </div>
        <div className="info_phone">
          <div className="dataphone">
            <div className="looower">
              <div className="twosteps">
                <div>
                  <h3>Token</h3>
                  <img src="\assets\tron.svg" />
                </div>
                <div className="symbol">
                  <h3>Symbol</h3>
                  <h4>Ron</h4>
                </div>
                <div></div>
              </div>
              <div className="twosteps">
                <div>
                  <h3>Token Decimal</h3>
                  <h4>18</h4>
                </div>
                <div>
                  <h3>Status</h3>
                  <h4>Active</h4>
                </div>
                <div></div>
              </div>
            </div>

            {/* Toggleable More Info Section */}
            {showMore && (
              <div className="moreinfodata">
                <div className="lowertype">
                  <h3>Contract Address</h3>
                  <h4>
                    0x97E68DC...79A
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M9.41377 7.57479L9.44015 10.0246C9.46213 12.0662 8.65431 12.8916 6.61276 12.9136L4.1629 12.94C2.12135 12.962 1.29594 12.1541 1.27396 10.1126L1.24757 7.66272C1.22559 5.62118 2.03342 4.79576 4.07496 4.77378L6.52482 4.7474C8.56637 4.72541 9.39178 5.53324 9.41377 7.57479Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8759 4.03731L12.9023 6.48717C12.9243 8.52872 12.1165 9.35413 10.0749 9.37612L9.43329 9.38303L9.41382 7.5748C9.39183 5.53325 8.56642 4.72542 6.52487 4.74741L4.71664 4.76688L4.70973 4.12525C4.68775 2.0837 5.49557 1.25829 7.53712 1.2363L9.98698 1.20992C12.0285 1.18794 12.8539 1.99576 12.8759 4.03731Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h4>
                </div>
                <div className="actionns">
                  <h3>Action</h3>
                  <div className="parent-toggle-switch-custom">
                    <div className="custom-toggle">
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="customToggle"
                        onChange={() => {}}
                      />
                      <label className="switch red" htmlFor="customToggle">
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Button to toggle More Info */}
            <div className="lessinfobutton" onClick={toggleMoreInfo}>
              {showMore ? "Less Info" : "More Info"}
              <svg
                className={showMore ? "rotated" : ""}
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="6"
                viewBox="0 0 9 6"
                fill="none"
              >
                <path
                  d="M7.90908 5.14282H4.09497H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                  fill="#02171D"
                />
              </svg>
            </div>
          </div>
          <div className="dataphone">
            <div className="looower">
              <div className="twosteps">
                <div>
                  <h3>Token</h3>
                  <img src="\assets\tron.svg" />
                </div>
                <div className="symbol">
                  <h3>Symbol</h3>
                  <h4>Ron</h4>
                </div>
                <div></div>
              </div>
              <div className="twosteps">
                <div>
                  <h3>Token Decimal</h3>
                  <h4>18</h4>
                </div>
                <div>
                  <h3>Status</h3>
                  <h4>Active</h4>
                </div>
                <div></div>
              </div>
            </div>

            {/* Toggleable More Info Section */}
            {showMore && (
              <div className="moreinfodata">
                <div className="lowertype">
                  <h3>Contract Address</h3>
                  <h4>
                    0x97E68DC...79A
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M9.41377 7.57479L9.44015 10.0246C9.46213 12.0662 8.65431 12.8916 6.61276 12.9136L4.1629 12.94C2.12135 12.962 1.29594 12.1541 1.27396 10.1126L1.24757 7.66272C1.22559 5.62118 2.03342 4.79576 4.07496 4.77378L6.52482 4.7474C8.56637 4.72541 9.39178 5.53324 9.41377 7.57479Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8759 4.03731L12.9023 6.48717C12.9243 8.52872 12.1165 9.35413 10.0749 9.37612L9.43329 9.38303L9.41382 7.5748C9.39183 5.53325 8.56642 4.72542 6.52487 4.74741L4.71664 4.76688L4.70973 4.12525C4.68775 2.0837 5.49557 1.25829 7.53712 1.2363L9.98698 1.20992C12.0285 1.18794 12.8539 1.99576 12.8759 4.03731Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h4>
                </div>
                <div className="actionns">
                  <h3>Action</h3>
                  <div className="parent-toggle-switch-custom">
                    <div className="custom-toggle">
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="customToggle"
                        onChange={() => {}}
                      />
                      <label className="switch red" htmlFor="customToggle">
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Button to toggle More Info */}
            <div className="lessinfobutton" onClick={toggleMoreInfo}>
              {showMore ? "Less Info" : "More Info"}
              <svg
                className={showMore ? "rotated" : ""}
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="6"
                viewBox="0 0 9 6"
                fill="none"
              >
                <path
                  d="M7.90908 5.14282H4.09497H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                  fill="#02171D"
                />
              </svg>
            </div>
          </div>
          <div className="dataphone">
            <div className="looower">
              <div className="twosteps">
                <div>
                  <h3>Token</h3>
                  <img src="\assets\tron.svg" />
                </div>
                <div className="symbol">
                  <h3>Symbol</h3>
                  <h4>Ron</h4>
                </div>
                <div></div>
              </div>
              <div className="twosteps">
                <div>
                  <h3>Token Decimal</h3>
                  <h4>18</h4>
                </div>
                <div>
                  <h3>Status</h3>
                  <h4>Active</h4>
                </div>
                <div></div>
              </div>
            </div>

            {/* Toggleable More Info Section */}
            {showMore && (
              <div className="moreinfodata">
                <div className="lowertype">
                  <h3>Contract Address</h3>
                  <h4>
                    0x97E68DC...79A
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M9.41377 7.57479L9.44015 10.0246C9.46213 12.0662 8.65431 12.8916 6.61276 12.9136L4.1629 12.94C2.12135 12.962 1.29594 12.1541 1.27396 10.1126L1.24757 7.66272C1.22559 5.62118 2.03342 4.79576 4.07496 4.77378L6.52482 4.7474C8.56637 4.72541 9.39178 5.53324 9.41377 7.57479Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8759 4.03731L12.9023 6.48717C12.9243 8.52872 12.1165 9.35413 10.0749 9.37612L9.43329 9.38303L9.41382 7.5748C9.39183 5.53325 8.56642 4.72542 6.52487 4.74741L4.71664 4.76688L4.70973 4.12525C4.68775 2.0837 5.49557 1.25829 7.53712 1.2363L9.98698 1.20992C12.0285 1.18794 12.8539 1.99576 12.8759 4.03731Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </h4>
                </div>
                <div className="actionns">
                  <h3>Action</h3>
                  <div className="parent-toggle-switch-custom">
                    <div className="custom-toggle">
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="customToggle"
                        onChange={() => {}}
                      />
                      <label className="switch red" htmlFor="customToggle">
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Button to toggle More Info */}
            <div className="lessinfobutton" onClick={toggleMoreInfo}>
              {showMore ? "Less Info" : "More Info"}
              <svg
                className={showMore ? "rotated" : ""}
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="6"
                viewBox="0 0 9 6"
                fill="none"
              >
                <path
                  d="M7.90908 5.14282H4.09497H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                  fill="#02171D"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="newsideedesktop">
          {tokenData?.length > 0
            ? tokenData?.map((item, index) => {
                return (
                  <>
                    <div className="accmblviewfdsasdf d-none">
                      <div className="main-twice-text">
                        <h6 className="accmblviewhead">Token</h6>
                        <h6 className="accmblviewhead">Status</h6>
                      </div>
                      <Accordion>
                        <Accordion.Item>
                          <Accordion.Header>
                            <div className="accheadermain">
                              <div className="forflex">
                                <div className="tokenimg">
                                  {item?.address ==
                                  "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" ? (
                                    <img
                                      src="\assets\ethereum-et.svg"
                                      alt="innertokenimg"
                                      className="innertokenimg"
                                    />
                                  ) : (
                                    <img
                                      src={item?.imageUrl}
                                      alt="innertokenimg"
                                      className="innertokenimg"
                                    />
                                  )}
                                </div>
                                {item?.address ==
                                "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" ? (
                                  <p className="tokenname">Ethereum</p>
                                ) : (
                                  <p className="tokenname">{item?.name}</p>
                                )}
                              </div>
                              {item?.status == false ? (
                                <p className="acctext red">Inactive</p>
                              ) : (
                                <p className="acctext green">Active</p>
                              )}
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="acctexts">
                              <h6 className="textleft">Symbol</h6>
                              <p className="textright">{item?.symbol}</p>
                            </div>
                            <div className="acctexts">
                              <h6 className="textleft">Decimals</h6>
                              <p className="textright">{item?.decimal}</p>
                            </div>
                            <div className="acctexts">
                              <h6 className="textleft">Contract Address</h6>
                              <div className="forflex">
                                {copy ? (
                                  <span
                                    className="adadasdasdasdasdasdsad"
                                    style={{ display: "flex" }}
                                  >
                                    <p className="textright">
                                      {item?.address?.slice(0, 7)}...
                                      {item?.address?.slice(
                                        item?.address?.length - 4,
                                        item?.address?.length
                                      )}{" "}
                                    </p>
                                    <svg
                                      style={{ cursor: "pointer" }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      className=""
                                    >
                                      <path
                                        d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </span>
                                ) : (
                                  <>
                                    {item?.address && (
                                      <CopyToClipboard
                                        text={item?.address}
                                        onCopy={textCopiedFun2}
                                      >
                                        <span
                                          className="adadasdasdasdasdasdsad"
                                          style={{ display: "flex" }}
                                        >
                                          <p className="textright">
                                            {item?.address?.slice(0, 7)}...
                                            {item?.address?.slice(
                                              item?.address?.length - 4,
                                              item?.address?.length
                                            )}{" "}
                                          </p>
                                          <svg
                                            style={{ cursor: "pointer" }}
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            className=""
                                          >
                                            <path
                                              d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                              stroke="#77868B"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                              stroke="#77868B"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </span>
                                      </CopyToClipboard>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      {/* <div className="footer-content">
            <div className="left-f">
            </div>
            <nav className="right-f">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    onClick={() => getPrevData(currentPage)}
                    className="page-link arrowssss scsdsdfefssdvsdvsd"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M10 13L5 8L10 3" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                  </button>
                </li>
                {pages?.map((item, index) => {
                  return (
                    <li key={index} className="page-item cursor-pointer">
                      <p
                        className={
                          "page-link " +
                          (index + 1 === parseInt(currentPage)
                            ? "active-pag"
                            : "")
                        }
                        onClick={() => GetAllRounds(index + 1)}
                        style={{ fontSize: "13px !important" }}
                      >
                        {index + 1}
                      </p>
                    </li>
                  );
                })}
                <li className="page-item">
                  <button
                    onClick={() => getNextData(currentPage)}
                    className="page-link arrowssss"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M5 13L10 8L5 3" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                  </button>
                </li>
              </ul>
            </nav>
          </div> */}
                    </div>
                  </>
                );
              })
            : null}
        </div>
      </section>
    </>
  );
};

export default DataTable;
